export default __webpack_public_path__ + "static/media/830.ed8489b9.png";